import styled from 'styled-components';
import {ArrowDownIcon,ArrowUpIcon} from '../../atoms/Icons';
import IconButton from '../../atoms/IconButton';
import {Grey500} from '../../Colors';

export default {
	Wrapper : styled.li`
        display : grid;
        grid-template-columns: 250px auto auto;
        align-items : center;
        &>:first-child{
            padding-right : 1rem;
        }
    `,
	ArrowDownIcon,
	ArrowUpIcon,
	IconButton : styled(IconButton)`
        color : ${Grey500};
        padding : 0 0.5rem;
    `
};